import cn from "@/lib/cn";
import { BLOG_PATH, NEWS_PORTAL_PATH } from "@/lib/constants";
import { MediaPost } from "@/types/media";
import { Calendar, UserCircle2Icon } from "lucide-react";
import Image from "next/image";
import Link from "next/link";

function RecentBlogsCard({ recentPost, className }: { recentPost: MediaPost; className?: string }) {
	return (
		<div
			className={cn(
				"relative flex flex-wrap items-center justify-between rounded-xl bg-white shadow-sm md:p-3",
				className
			)}
		>
			<div className="flex flex-wrap items-center gap-4 md:flex-nowrap">
				<div className="w-full md:max-w-xs">
					<Image
						src={recentPost.featured_media}
						alt="Recent blogs"
						className="h-full w-full rounded object-cover"
						width={400}
						height={380}
					/>
				</div>

				<div className="flex flex-col flex-wrap items-start justify-between gap-4 p-3 md:flex-wrap">
					<Link
						href={
							recentPost?.type == "blog"
								? `${BLOG_PATH}/${recentPost.slug}`
								: `${NEWS_PORTAL_PATH}/${recentPost.slug}`
						}
					>
						<h3
							className="text-lg font-semibold text-gray-800 md:text-xl"
							dangerouslySetInnerHTML={{ __html: recentPost.title }}
						/>
					</Link>

					<div className="flex gap-3">
						<div className="flex items-center gap-1">
							<UserCircle2Icon size={20} className="stroke-gray-600" />
							<p className="text-sm text-gray-600">By {recentPost.authorName}</p>
						</div>

						<div className="flex items-center gap-1">
							<Calendar size={18} className="stroke-brand-primary" />
							<p className="text-sm text-gray-600">{recentPost.date_created}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default RecentBlogsCard;
